module.exports = __webpack_public_path__ + "img/ball.a2907b7b.png";